import { Component, Input } from '@angular/core'
import { TooltipComponent } from 'src/app/elements/tooltip/tooltip.component'

@Component({
  selector: 'app-content-block',
  templateUrl: './content-block.component.html',
  styleUrl: './content-block.component.sass',
  imports: [
    TooltipComponent,
  ],
})
export class ContentBlockComponent {
  @Input() content!: {
    headline: string
    text: string
  }
}
